import View from './View';
import watch from './View/watch';

/**
 * Create accordion.
 * @param {string|HTMLElement} selector Selector or HTML element
 * @param {object} initialState
 */
export default (selector, initialState = {}) => {
	const state = {
		isOpened: false,
		...initialState,
	};

	const view = new View(selector);
	const watchedState = watch(state, view);

	const handleToggleClick = () => {
		watchedState.isOpened = !watchedState.isOpened;
	};

	view.init({ handleToggleClick });

	view.toggleContentVisibility(watchedState.isOpened);
};
